<div class="icon">
  <img
    class="source-icon"
    alt=""
    src="https://www.ancestrycdn.com/stories/static/images/images/storyscout-book-error-a0a0a0.svg"
  />
</div>
<span>
  @switch (mistake?.pageErrorType) {
    @case (PageErrorType.stories) {
      <p class="error-content">
        <span
          i18n="
            Error message for StoryScout issues|Message indicating that StoryScout is experiencing problems and assuring
            the user that their stories will return soon.@@Stories73d2c8e83b7b43feb20ea9644228763c"
          >StoryScout is experiencing problems.<br />Don’t worry, your stories will be back soon!<br />Go back to</span
        >
        <button (click)="goToStories()" type="button" class="link">{{ siteTitle }}</button>.
      </p>
    }
    @case (PageErrorType.connect) {
      <p class="error-content">
        <span
          i18n="
            Error message for result display issues|Message indicating trouble in displaying results and advising the
            user to try their search later.@@Storiesf3e11777515a458d8af40da42ed01f3e"
          >We’re having trouble displaying your results.<br />Please try your search later.<br />Go back to</span
        >
        <button (click)="goToStories()" type="button" class="link">{{ siteTitle }}</button>.
      </p>
    }
    @case (PageErrorType.getStories) {
      <p class="error-content">
        <span
          i18n="
            Error message for StoryScout unavailability|Message indicating that StoryScout is temporarily unavailable
            and encouraging the user to try again later.@@Storiesb1ccb5f009b74d2491181ac6ad8e37f9"
          >We’re sorry, StoryScout is temporarily unavailable. We are still looking for stories about your grandparent
          and relatives.<br />Try again later at</span
        >
        <button (click)="goToStories()" type="button" class="link">{{ siteTitle }}</button>.
      </p>
    }
    @case (PageErrorType.default) {
      <p class="error-content">
        <span
          i18n="
            General error message for StoryScout unavailability|General message indicating that StoryScout is
            temporarily unavailable and suggesting to try again later.@@Stories7becf267469047f68b73d280fcbb10e6"
          >We’re sorry, StoryScout is temporarily unavailable.<br />Try again later at</span
        >
        <button (click)="goToStories()" type="button" class="link">{{ siteTitle }}</button>.
      </p>
    }
  }
</span>
